/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ParentRelationship {
    ComplaintRequest = 0,
    OriginalSplit = 1,
    SourceStamped = 2
}

export function ParentRelationshipFromJSON(json: any): ParentRelationship {
    return ParentRelationshipFromJSONTyped(json, false);
}

export function ParentRelationshipFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParentRelationship {
    return json as ParentRelationship;
}

export function ParentRelationshipToJSON(value?: ParentRelationship | null): any {
    return value as any;
}

